<template>
  <div class="site_content">
    <div class="row site">

      <section class="config-form primary col-12">
        <div class="content-text">
          <div class="title site">
            <h4>Banner</h4>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="bloco1_active"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Imagem</label>
            </div>
            <div class="form-file">
              <div class="file-wrapper primary">
                <span class="thumbnail">
                  <span class="icon">
                    <svg
                    width="46"
                    height="39"
                    viewBox="0 0 46 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                      stroke="#9D9FA3"
                      stroke-width="1.25714"
                    ></path>
                    <rect
                      x="1.00049"
                      y="1.40454"
                      width="43.9461"
                      height="36.1909"
                      rx="2.58507"
                      stroke="#9D9FA3"
                      stroke-width="1.25714"
                    ></rect>
                    <circle
                      cx="14.8948"
                      cy="10.6676"
                      r="3.71629"
                      stroke="#9D9FA3"
                      stroke-width="1.25714"
                    ></circle>
                  </svg>                  </span>
                  <span class="text">
                    Clique aqui para selecionar a imagem
                  </span>
                  <span class="text">
                   1920x1080
                  </span>
                </span>
                <input class="form-control" type="file" @change="updateFilePathBanner1"   accept=".png, .jpg, .jpeg, .webp"/>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Título:</label>
            </div>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                placeholder="Curso X - O melhor curso de matemática do mercado"
                v-model="bloco1_title"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Endereço da URL:</label>
            </div>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                placeholder="https://seucurso.com.br"
                v-model="bloco1_link"
              />
            </div>
          </div>

          <div class="form-group">
            <div class="form-label">
              <label>Descrição</label>
            </div>
            <div class="form-input">
              <textarea
                placeholder="Somos o maior curso de matemática..."
                v-model="bloco1_description"
              ></textarea>
            </div>
          </div>
        </div>
      </section>

      <section class="config-form primary col-12">
        <div class="content-text">
          <div class="title site">
            <h4>Listagem de Cursos</h4>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="bloco2_active"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Título:</label>
            </div>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                placeholder="Veja o que os alunos estão dizendo"
                v-model="bloco2_title"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="config-form primary col-12">
        <div class="content-text">
          <div class="title site">
            <h4>Conteúdo Institucional</h4>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="bloco3_active"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Imagem</label>
            </div>
            <div class="form-file">
              <div class="file-wrapper primary">
                <span class="thumbnail">
                  <span class="icon">
                    <svg
                    width="46"
                    height="39"
                    viewBox="0 0 46 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                      stroke="#9D9FA3"
                      stroke-width="1.25714"
                    ></path>
                    <rect
                      x="1.00049"
                      y="1.40454"
                      width="43.9461"
                      height="36.1909"
                      rx="2.58507"
                      stroke="#9D9FA3"
                      stroke-width="1.25714"
                    ></rect>
                    <circle
                      cx="14.8948"
                      cy="10.6676"
                      r="3.71629"
                      stroke="#9D9FA3"
                      stroke-width="1.25714"
                    ></circle>
                  </svg>                  </span>
                  <span class="text">
                    Clique aqui para selecionar a imagem
                  </span>
                </span>
                <input class="form-control" type="file" @change="updateFilePathBanner3"  accept=".png, .jpg, .jpeg, .webp"/>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Título:</label>
            </div>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                placeholder="Curso X - O melhor curso de matemática do mercado"
                v-model="bloco3_title"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Endereço da URL:</label>
            </div>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                placeholder="https://seucurso.com.br"
                v-model="bloco3_link"
              />
            </div>
          </div>

          <div class="form-group">
            <div class="form-label">
              <label>Descrição</label>
            </div>
            <div class="form-input">
              <textarea
                placeholder="Somos o maior curso de matemática..."
                v-model="bloco3_description"
              ></textarea>
            </div>
          </div>
        </div>
      </section>

      <section class="config-form primary col-12">
        <div class="content-text">
          <div class="title site">
            <h4>Depoimentos</h4>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="bloco4_active"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label>Título:</label>
            </div>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                placeholder="Veja o que os alunos estão dizendo"
                v-model="bloco4_title"
              />
            </div>
          </div>
        </div>
      </section>

    </div>
    <div class="row site demo">
      {{ bloco1_active }}

      <section class="config-form primary col-12" :class="!bloco1_active?'blur':'' ">
        <div class="box_1">
            <div class="banner">
              <div class="banner-content">
                <img src='../../../assets//1920x1080.png' alt="" v-show="!bloco1_banner"/>
                <img :src="bloco1_bannerPreview" alt="" v-show="bloco1_banner"/>
                <div class="banner-text">
                  <h2>{{bloco1_title}}</h2>
                  <p>{{bloco1_description}}</p>
                </div>
              </div>
          </div>
        </div>
      </section>

      <section class="config-form primary col-12 itens-courses" :class="!bloco2_active?'blur':'' ">
          <p>{{bloco2_title}}</p>
          <div class="box_2" v-for="item, i in 8" :key="i">
          <div class="cursos">
            <div class="banner-content cursos">
              <img src='../../../assets/190x112.png' alt="" />
              <div class="banner-text">
              </div>
            </div>
        </div>
      </div>
      </section>

      <section class="config-form primary col-12 itens-courses" :class="!bloco3_active?'blur':'' ">
        <div class="box_3" >
        <div class="cursos">
          <div class="banner-content cursos">
            <img src='../../../assets/1920x1080.png' alt="" v-show="!bloco3_banner"/>
            <img :src="bloco3_bannerPreview" alt="" v-show="bloco3_banner"/>
            <div class="banner-text">
              <p></p>
            </div>
          </div>
      </div>
    </div>
      </section>

      <section class="config-form primary col-12" :class="!bloco4_active?'blur':'' ">
        <div class="box_4">
            <div class="banner">
                  <p>{{bloco4_title}}</p>
          </div>
        </div>
      </section>

    </div>
  </div>
  <div class="content-button site">
    <div class="button">
      <button type="button" @click="save" class="btn btn-block btn-content">
        Salvar e Publicar
      </button>
      <button type="button" class="btn btn-block btn-content">Voltar</button>
      <button type="button" class="btn btn-block btn-content">
        Limpar Cache
      </button>
    </div>
  </div>
</template>

<script>
import MultiSelect from '@/components/MultiSelect/MultiSelect.vue';
import api from '@/utils/site';
import apiSiteContent from '@/utils/Site/content';
import apiAWS from '@/utils/storage/aws';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      listContents:[],

      bloco1_active: false,
      bloco2_active: false,
      bloco3_active: false,
      bloco4_active: false,

      bloco1_banner: '', 
      bloco1_bannerPreview: null, 
      bloco1_title: '',
      bloco1_link: '',
      bloco1_description: '',

      bloco2_title: '',

      bloco3_banner: '', 
      bloco3_bannerPreview: null, 
      bloco3_title: '',
      bloco3_link: '',
      bloco3_description: '',
      
      bloco4_title: '',

      idSite:null,  
    };
  },
  computed: {
    ...mapState(['token'])
  },
  methods: {
    async putFileAws(url, file){
      try {
          const response = await apiAWS.putFileAWS(url, file);
      } catch (error) {
          console.error('Erro ao enviar arquivo para AWS');
      }
    },
    async updateFilePathBanner1(event){
        const file = event.target.files[0];
        this.bloco1_bannerPreview = URL.createObjectURL(file)

        try {
            const response =  await apiAWS.getSignatureImage(this.token, file.name);
            this.putFileAws(response.url, file)
            this.bloco1_banner = response.token;
            console.debug(response);
        } catch (error) {
            console.error('Erro na geração do TOKEN AWS')
        }
    },
    async updateFilePathBanner3(event){
        const file = event.target.files[0];
        this.bloco3_bannerPreview = URL.createObjectURL(file)

        try {
            const response =  await apiAWS.getSignatureImage(this.token, file.name);
            this.putFileAws(response.url, file)
            this.bloco3_banner = response.token;
            console.debug(response);
        } catch (error) {
            console.error('Erro na geração do TOKEN AWS')
        }
    },
    async save() {
   
      const content_1 = 
      {
        'id':this.listContents[0].id,
        "type": 1,
        "title": this.bloco1_title,
        "description": this.bloco1_description,
        "pathImage": this.bloco1_banner,
        "url": this.bloco1_link,
        "order": 1,
        "status": this.bloco1_active == true ? 1 : 0,
      }

      const content_2 = 
      {
        'id':this.listContents[1].id,
        "type": 2,
        "title": this.bloco2_title,
        "description": '',
        "pathImage": '',
        "url": '',
        "order": 2,
        "status": this.bloco2_active == true ? 1 : 0,
      }

      const content_3 = 
      {
        'id':this.listContents[2].id,
        "type": 3,
        "title": this.bloco3_title,
        "description": this.bloco3_description,
        "pathImage": this.bloco3_banner,
        "url": this.bloco3_link,
        "order": 3,
        "status": this.bloco3_active == true ? 1 : 0,
      }
      const content_4 = 
      {
        'id':this.listContents[3].id,
        "type": 2,
        "title": this.bloco4_title,
        "description": '',
        "pathImage": '',
        "url": '',
        "order": 2,
        "status": this.bloco4_active == true ? 1 : 0,
      }

      const formData = [content_1, content_2, content_3, content_4]

      try {
          const response = await apiSiteContent.putContentData(this.token, formData);

          this.getContetData();
      
      } catch (error) {
        console.error(error);
      }
    },
    async getContetData(){
      try {
       const response = await apiSiteContent.getContentData(this.token);
       this.listContents = response;
       this.bloco1_active =  response[0].status == 1 ? true : false,
       this.bloco2_active =  response[1].status == 1 ? true : false,
       this.bloco3_active =  response[2].status == 1 ? true : false,
       this.bloco4_active =  response[3].status == 1 ? true : false,

       this.bloco1_banner = response[0].pathImage;
       this.bloco1_bannerPreview = response[0].pathImageFinal;
       this.bloco1_title = response[0].title;
       this.bloco1_link = response[0].url;
       this.bloco1_description = response[0].description;

       this.bloco2_title = response[1].title;

       this.bloco3_banner =  response[2].pathImage;
       this.bloco3_bannerPreview = response[2].pathImageFinal;

       this.bloco3_title = response[2].title;
       this.bloco3_link = response[2].url;
       this.bloco3_description = response[2].description;

       this.bloco4_title = response[3].title;

      } catch (error) {
        console.error(error);
      }
    },
  },
  components: {
    MultiSelect,
  },
  created() {
    this.getContetData();
  },
};
</script>
<style scoped>
img {
  border-radius: 5px;
}
.site_content {
  display: flex;
  justify-content: space-between;
}
.content-text {
  border: 1px solid #d7d7d7;
  border-radius: 10px 10px 0px 0px;
}
.form-group .form-input textarea {
  width: 100%;
  min-height: 7em;
  border-color: #dee2e6;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}
.form-group {
  text-align: left;
  margin: 0.5em 1em;
}
.form-group .form-input textarea:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
input.correct.form-control {
  font-weight: 700;
}
.answer_quiz {
  margin: 5px 0px;
}

.row.site {
  display: block;
  width: 51%;
}
.button-order {
  display: flex;
  width: auto;
}
.title.site {
  display: flex;
  gap: 10px;
  background-color: #1ac7d0;
  color: white;
  padding: 10px;
  align-items: center;
  border-radius: 10px 10px 0px 0px;
  justify-content: space-between;
}
.title.site h4 {
  margin: 0;
}
.form-check-input:checked {
  background-color: #2b9ea4;
  border-color: #2b9ea4;
}
.banner-content {
  width: 100%;
  height: auto !important;
}
.banner-content img {
  width: 100%;
}
.blur {
  filter: blur(10px);
}
section.config-form.primary.col-12 {
  transition: all 500ms ease-out;
}
.banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
}

.banner-content {
  position: relative;
}
.site.demo section.config-form.primary.col-12 {
  border: 1px solid #ececec;
  margin: 20px 0px;
  width: 100%;
  border-radius: 0.5em;
}
section.config-form.primary.col-12.itens-courses {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  justify-content: center;
}
.box_2 {
  width: 24%;
}
section.config-form.primary.col-12.itens-courses .banner-text {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  width: 100%;
}
section.config-form.primary.col-12.itens-courses .banner-text p  {
  font-size: 12px;
}
section.config-form.primary.col-12.itens-courses > p {
  display: block;
  width: 100%;
}
.site_content textarea {
  padding: 10px;
}
@media (max-width: 500px) {
  .site_content {
    display: block;
  }
  .row.site {
    display: block;
    width: auto;
  }
}
</style>
